module.exports = __webpack_public_path__ + "static/smarty-content-d6a8687f8ea8c528b5497f3bc180837d.png";